import markConversationsReadInListViewStore from '../actions/triage/markConversationsReadInListViewStore';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import { listViewStore } from 'owa-mail-list-store';
import { getRowKeysFromRowIds, shouldRemoveRowOnMarkReadAction } from 'owa-mail-list-store';
import { createLazyOrchestrator } from 'owa-bundling';
import tombstoneOperations, { TombstoneReasonType } from 'owa-mail-list-tombstone';
import removeRowsFromListViewStore from 'owa-mail-actions/lib/triage/removeRowsFromListViewStore';

export default createLazyOrchestrator(
    markConversationsAsReadStoreUpdate,
    'clone_markConversationAsReadStoreUpdate',
    actionMessage => {
        const { conversationIds, tableViewId, isReadValue, isExplicit } = actionMessage;

        // Get all the rowKeys for the given conversation and update the unread count
        const tableView = listViewStore.tableViews.get(tableViewId);
        const rowKeys = getRowKeysFromRowIds(conversationIds, tableView);

        // 1. Make instant update to the read state and unread count
        markConversationsReadInListViewStore(
            rowKeys,
            isReadValue,
            tableView,
            true /* updateFolderCounts */
        );

        if (shouldRemoveRowOnMarkReadAction(tableView, isReadValue, isExplicit)) {
            // 2. Add rowKeys for the rows that are to be removed to tombstone so they don't pop back in
            tombstoneOperations.add(
                rowKeys,
                tableView.serverFolderId,
                TombstoneReasonType.RowRemove
            );

            // 3. Make an instant update to the view by removing the row
            removeRowsFromListViewStore(rowKeys, tableView);
        } else {
            // 2. Add rowKeys for the rows that are to be marked as read to tombstone
            // so that read state does not flicker upon incorrect/partial notifications
            tombstoneOperations.add(rowKeys, tableView.serverFolderId, TombstoneReasonType.Read);
        }
    }
);
